(function(){
  'use strict';

  if(!window.ppuProductHandle) return;

  var handle = window.ppuProductHandle;

  var MAP = {
    'glp-1-support-capsules':[
      {h:'glp-1-synbiotic',n:'GLP-1 Synbiotic',b1:'Gut Health & Appetite Support',b2:'Bloating & Digestion Support',b:'Pairs Well'},
      {h:'totalmag-13-in-1-magnesium-complex',n:'TotalMag',b1:'Complete Magnesium Coverage',b2:'Sleep, Stress, Muscle & Brain',b:'Bestseller'},
      {h:'zeolite-detox-complex',n:'Zeolite Detox',b1:'Heavy Metal Detox',b2:'Cleanse & Toxin Support',b:''}
    ],
    'magplus-7-in-1-sleep-formula':[
      {h:'totalmag-13-in-1-magnesium-complex',n:'TotalMag',b1:'Complete Magnesium Coverage',b2:'Sleep, Stress, Muscle & Brain',b:'Bestseller'},
      {h:'glp-1-support-capsules',n:'GLP-1 Support',b1:'Weight Loss & Cravings',b2:'Metabolic & Energy Support',b:'Bestseller'},
      {h:'urolithin-a-longevity-complex',n:'Urolithin A',b1:'Cellular Energy & Longevity',b2:'Mitochondrial Renewal',b:''}
    ],
    'totalmag-13-in-1-magnesium-complex':[
      {h:'magplus-7-in-1-sleep-formula',n:'MAG+ 7-in-1',b1:'Restorative Sleep',b2:'Cognitive Function',b:'Bestseller'},
      {h:'glp-1-support-capsules',n:'GLP-1 Support',b1:'Weight Loss & Cravings',b2:'Metabolic & Energy Support',b:'Bestseller'},
      {h:'glo-liposomal-glutathione',n:'GLO Glutathione',b1:'Skin That Glows From Within',b2:'Cellular Defense & Detox',b:''}
    ],
    'testplus-testosterone-support':[
      {h:'shilajit-resin-complex',n:'Shilajit Resin',b1:'Energy & Stamina Support',b2:'Hormonal & Adaptogen Support',b:'Pairs Well'},
      {h:'maca-complex',n:'Maca Complex',b1:'Hormonal Balance & Vitality',b2:'Endurance & Performance',b:'Bestseller'},
      {h:'magplus-7-in-1-sleep-formula',n:'MAG+ 7-in-1',b1:'Recovery & Deep Sleep',b2:'Cognitive Function',b:'Bestseller'}
    ],
    'maca-complex':[
      {h:'testplus-testosterone-support',n:'TestPlus',b1:'Testosterone & Strength',b2:'Drive & Performance Support',b:'Bestseller'},
      {h:'viva-la-v-feminine-balance-gummies',n:'Viva La V',b1:'pH Balance & Intimate Comfort',b2:'Daily Probiotic Gummy',b:''},
      {h:'magplus-7-in-1-sleep-formula',n:'MAG+ 7-in-1',b1:'Restorative Sleep',b2:'Stress & Recovery Support',b:'Bestseller'}
    ],
    'urolithin-a-longevity-complex':[
      {h:'glo-liposomal-glutathione',n:'GLO Glutathione',b1:'Skin That Glows From Within',b2:'Cellular Defense & Detox',b:''},
      {h:'totalmag-13-in-1-magnesium-complex',n:'TotalMag',b1:'Complete Magnesium Coverage',b2:'Sleep, Stress, Muscle & Brain',b:'Bestseller'},
      {h:'shilajit-resin-complex',n:'Shilajit Resin',b1:'Energy & Stamina Support',b2:'Hormonal & Adaptogen Support',b:'Pairs Well'}
    ],
    'glo-liposomal-glutathione':[
      {h:'zeolite-detox-complex',n:'Zeolite Detox',b1:'Heavy Metal Detox',b2:'Cleanse & Toxin Support',b:''},
      {h:'urolithin-a-longevity-complex',n:'Urolithin A',b1:'Cellular Energy & Longevity',b2:'Mitochondrial Renewal',b:''},
      {h:'totalmag-13-in-1-magnesium-complex',n:'TotalMag',b1:'Complete Magnesium Coverage',b2:'Sleep, Stress, Muscle & Brain',b:'Bestseller'}
    ],
    'zeolite-detox-complex':[
      {h:'glo-liposomal-glutathione',n:'GLO Glutathione',b1:'Skin That Glows From Within',b2:'Cellular Defense & Detox',b:''},
      {h:'glp-1-synbiotic',n:'GLP-1 Synbiotic',b1:'Gut Health & Appetite Support',b2:'Bloating & Digestion Support',b:'Pairs Well'},
      {h:'totalmag-13-in-1-magnesium-complex',n:'TotalMag',b1:'Complete Magnesium Coverage',b2:'Sleep, Stress, Muscle & Brain',b:'Bestseller'}
    ],
    'shilajit-resin-complex':[
      {h:'testplus-testosterone-support',n:'TestPlus',b1:'Testosterone & Strength',b2:'Drive & Performance Support',b:'Bestseller'},
      {h:'maca-complex',n:'Maca Complex',b1:'Hormonal Balance & Vitality',b2:'Endurance & Performance',b:'Bestseller'},
      {h:'magplus-7-in-1-sleep-formula',n:'MAG+ 7-in-1',b1:'Recovery & Deep Sleep',b2:'Cognitive Function',b:'Bestseller'}
    ],
    'glp-1-synbiotic':[
      {h:'glp-1-support-capsules',n:'GLP-1 Support',b1:'Weight Loss & Cravings',b2:'Metabolic & Energy Support',b:'Bestseller'},
      {h:'totalmag-13-in-1-magnesium-complex',n:'TotalMag',b1:'Complete Magnesium Coverage',b2:'Sleep, Stress, Muscle & Brain',b:'Bestseller'},
      {h:'zeolite-detox-complex',n:'Zeolite Detox',b1:'Heavy Metal Detox',b2:'Cleanse & Toxin Support',b:''}
    ],
    'glp-1-gummies':[
      {h:'glp-1-support-capsules',n:'GLP-1 Support',b1:'Weight Loss & Cravings',b2:'Metabolic & Energy Support',b:'Bestseller'},
      {h:'glp-1-synbiotic',n:'GLP-1 Synbiotic',b1:'Gut Health & Appetite Support',b2:'Bloating & Digestion Support',b:'Pairs Well'},
      {h:'magplus-7-in-1-sleep-formula',n:'MAG+ 7-in-1',b1:'Restorative Sleep',b2:'Stress & Recovery Support',b:'Bestseller'}
    ],
    'viva-la-v-feminine-balance-gummies':[
      {h:'maca-complex',n:'Maca Complex',b1:'Hormonal Balance & Vitality',b2:'Endurance & Performance',b:'Bestseller'},
      {h:'magplus-7-in-1-sleep-formula',n:'MAG+ 7-in-1',b1:'Restorative Sleep',b2:'Cognitive Function',b:'Bestseller'},
      {h:'glo-liposomal-glutathione',n:'GLO Glutathione',b1:'Skin That Glows From Within',b2:'Cellular Defense & Detox',b:''}
    ]
  };

  var SPECS = {
    'glp-1-synbiotic': {d:'Pre, Pro & Postbiotic',s1:'20-in-1 Formula',s2:'2B Synbiotic Strains'},
    'glp-1-support-capsules': {d:'10-in-1 Metabolic Formula',s1:'10-in-1 Formula',s2:'GLP-1 Activating'},
    'totalmag-13-in-1-magnesium-complex': {d:'Complete Magnesium Complex',s1:'13-in-1 Formula',s2:'7 Magnesium Types'},
    'magplus-7-in-1-sleep-formula': {d:'Magnesium Sleep Formula',s1:'7-in-1 Formula',s2:'L-Threonate Core'},
    'testplus-testosterone-support': {d:'Testosterone Support',s1:'8-in-1 Formula',s2:'Tongkat Ali 200:1'},
    'shilajit-resin-complex': {d:'Fulvic Acid & Minerals',s1:'Pure Resin Form',s2:'80%+ Fulvic Acid'},
    'maca-complex': {d:'Hormonal Balance Complex',s1:'6-Root Blend',s2:'Gelatinized Maca'},
    'urolithin-a-longevity-complex': {d:'Cellular Longevity',s1:'10-in-1 Formula',s2:'Longevity Formula'},
    'glo-liposomal-glutathione': {d:'Liposomal Glutathione',s1:'11-in-1 Formula',s2:'Liposomal Delivery'},
    'zeolite-detox-complex': {d:'Heavy Metal Detox',s1:'8-in-1 Formula',s2:'Clinoptilolite Core'},
    'viva-la-v-feminine-balance-gummies': {d:'Feminine Balance Gummy',s1:'8-in-1 Formula',s2:'Cranberry + Probiotics'}
  };

  var styleElement = document.createElement('style');
  styleElement.textContent = '' +
    '.pu-protocol-section {' +
      'padding: 80px 0;' +
      'background: transparent;' +
    '}' +
    '.pu-protocol-section.section-reveal {' +
      'opacity: 1;' +
    '}' +
    '.pu-protocol-section.visible {' +
      'visibility: visible;' +
    '}' +
    '.pu-protocol-header {' +
      'text-align: center;' +
      'margin-bottom: 48px;' +
    '}' +
    '.pu-protocol-headline {' +
      'font-family: \'Cormorant Garamond\', serif;' +
      'font-family: \'Cormorant Garamond\', Georgia, serif;' +
      'font-size: clamp(2rem,3.2vw,2.8rem);' +
      'font-weight: 300;' +
      'line-height: 1.12;' +
      'color: #1a2e1a;' +
      'letter-spacing: -0.02em;' +
      'margin: 0 0 8px 0;' +
    '}' +
    '.pu-protocol-headline em{font-style:italic;color:#2B4C3F}' +
    '.pu-atmos-glow {' +
      'display: inline-block;' +
    '}' +
    '.pu-protocol-subheadline {' +
      'font-family: \'DM Sans\', sans-serif;' +
      'font-size: 15px;' +
      'color: rgba(31,61,43,0.5);' +
      'margin: 6px auto 0 auto;' +
      'text-align: center;' +
      'display: block;' +
      'max-width: none;' +
    '}' +
    '.pu-protocol-grid {' +
      'display: grid;' +
      'grid-template-columns: repeat(3, 1fr);' +
      'gap: 20px;' +
      'max-width: 1200px;' +
      'margin: 0 auto;' +
      'padding: 0 24px;' +
    '}' +
    '.pu-protocol-card {' +
      'display: flex;' +
      'flex-direction: column;' +
      'background: #FAFAF7;' +
      'border: 1px solid rgba(0,0,0,0.06);' +
      'border-radius: 12px;' +
      'padding: 20px;' +
      'text-decoration: none;' +
      'color: inherit;' +
      'cursor: pointer;' +
      'position: relative;' +
      'overflow: hidden;' +
      'transition: transform 0.25s ease, box-shadow 0.25s ease, border-color 0.25s ease;' +
    '}' +
    '.pu-protocol-card:hover {' +
      'transform: translateY(-3px);' +
      'box-shadow: 0 8px 24px rgba(0,0,0,0.08);' +
      'border-color: rgba(0,0,0,0.12);' +
    '}' +
    '.pu-protocol-card:hover img {' +
      'transform: scale(1.04);' +
    '}' +
    '.pu-protocol-card:hover .pu-protocol-cta {' +
      'opacity: 0.88;' +
    '}' +
    '.pu-protocol-badge {' +
      'position: absolute;' +
      'top: 14px;' +
      'left: 14px;' +
      'font-family: \'DM Sans\', sans-serif;' +
      'font-size: 10px;' +
      'font-weight: 600;' +
      'letter-spacing: 0.06em;' +
      'text-transform: uppercase;' +
      'padding: 4px 10px;' +
      'border-radius: 4px;' +
      'z-index: 1;' +
    '}' +
    '.pu-badge-bs {' +
      'background: rgba(31,61,43,0.08);' +
      'color: #1F3D2B;' +
    '}' +
    '.pu-badge-pw {' +
      'background: rgba(198,169,107,0.12);' +
      'color: #9E7E42;' +
    '}' +
    '.pu-badge-new {' +
      'background: rgba(31,61,43,0.08);' +
      'color: #1F3D2B;' +
    '}' +
    '.pu-protocol-img-wrap {' +
      'display: flex;' +
      'align-items: center;' +
      'justify-content: center;' +
      'height: 240px;' +
      'margin-bottom: 16px;' +
    '}' +
    '.pu-protocol-img-wrap img {' +
      'max-height: 208px;' +
      'max-width: 100%;' +
      'object-fit: contain;' +
      'transition: transform 0.3s ease;' +
    '}' +
    '.pu-protocol-body {' +
      'display: flex;' +
      'flex-direction: column;' +
      'flex: 1;' +
    '}' +
    '.pu-protocol-name {' +
      'font-family: \'DM Sans\', sans-serif;' +
      'display: none;' +
    '}' +
    '.pu-protocol-descriptor {' +
      'font-family: \'DM Sans\', sans-serif;' +
      'font-size: 18px;' +
      'font-weight: 600;' +
      'color: #1F3D2B;' +
      'margin: 0 0 12px 0;' +
      'line-height: 1.3;' +
    '}' +
    '.pu-protocol-benefits {' +
      'display: flex;' +
      'flex-direction: column;' +
      'gap: 4px;' +
      'margin-bottom: 14px;' +
    '}' +
    '.pu-protocol-check {' +
      'font-family: \'DM Sans\', sans-serif;' +
      'font-size: 13px;' +
      'color: #1F3D2B;' +
      'line-height: 1.4;' +
    '}' +
    '.pu-protocol-checkmark {' +
      'color: #C6A96B;' +
      'margin-right: 4px;' +
    '}' +
    '.pu-protocol-divider {' +
      'height: 1px;' +
      'background: rgba(0,0,0,0.06);' +
      'margin-bottom: 12px;' +
    '}' +
    '.pu-protocol-specs {' +
      'display: flex;' +
      'align-items: center;' +
      'gap: 8px;' +
      'margin-bottom: 16px;' +
    '}' +
    '.pu-protocol-spec {' +
      'font-family: \'DM Sans\', sans-serif;' +
      'font-size: 12px;' +
      'color: rgba(31,61,43,0.45);' +
      'font-weight: 500;' +
    '}' +
    '.pu-protocol-spec-dot {' +
      'width: 3px;' +
      'height: 3px;' +
      'border-radius: 50%;' +
      'background: rgba(31,61,43,0.2);' +
      'flex-shrink: 0;' +
    '}' +
    '.pu-protocol-footer {' +
      'display: flex;' +
      'align-items: center;' +
      'justify-content: space-between;' +
      'margin-top: auto;' +
    '}' +
    '.pu-protocol-pricing {' +
      'display: flex;' +
      'flex-direction: column;' +
    '}' +
    '.pu-protocol-daily {' +
      'font-family: \'DM Sans\', sans-serif;' +
      'font-size: 17px;' +
      'color: #C6A96B;' +
      'font-weight: 500;' +
      'line-height: 1.3;' +
    '}' +
    '.pu-protocol-cta {' +
      'font-family: \'DM Sans\', sans-serif;' +
      'font-size: 13px;' +
      'font-weight: 500;' +
      'color: #fff;' +
      'background: linear-gradient(135deg, #1F3D2B 0%, #2A5238 100%);' +
      'padding: 9px 20px;' +
      'border-radius: 100px;' +
      'white-space: nowrap;' +
      'transition: opacity 0.2s ease;' +
      'display: inline-block;' +
    '}' +
    '@media (max-width: 899px) {' +
      '.pu-protocol-grid {' +
        'grid-template-columns: 1fr;' +
      '}' +
      '.pu-protocol-card {' +
        'flex-direction: row;' +
      '}' +
      '.pu-protocol-img-wrap {' +
        'width: 150px;' +
        'height: auto;' +
        'flex-shrink: 0;' +
        'margin-bottom: 0;' +
        'margin-right: 16px;' +
      '}' +
      '.pu-protocol-img-wrap img {' +
        'max-height: 143px;' +
      '}' +
      '.pu-protocol-section {' +
        'padding: 56px 0;' +
      '}' +
      '.pu-protocol-headline {' +
        'font-size: clamp(1.6rem,5vw,2rem);' +
      '}' +
    '}' +
    '@media (max-width: 479px) {' +
      '.pu-protocol-card {' +
        'padding: 16px;' +
      '}' +
      '.pu-protocol-img-wrap {' +
        'width: 100px;' +
      '}' +
      '.pu-protocol-img-wrap img {' +
        'max-height: 117px;' +
      '}' +
      '.pu-protocol-name {' +
        'display: none;' +
      '}' +
      '.pu-protocol-grid {' +
        'gap: 14px;' +
        'padding: 0 16px;' +
      '}' +
      '.pu-protocol-headline {' +
        'font-size: 28px;' +
      '}' +
    '}' +
  '';
  document.head.appendChild(styleElement);

  function perDay(price) {
    return (price / 30).toFixed(2);
  }

  function buildCard(product, meta) {
    var priceStr = product.variants && product.variants[0] && product.variants[0].price ? product.variants[0].price : '0';
    var priceNum = parseFloat(priceStr);
    if (priceNum > 500) {
      priceNum = priceNum / 100;
    }
    var lowestPrice = priceNum.toFixed(2);
    var dailyPrice = priceNum >= 35 ? '0.67' : '0.47';

    var badgeClass = '';
    var showBadge = false;
    if (meta.b === 'Bestseller') {
      badgeClass = 'pu-badge-bs';
      showBadge = true;
    } else if (meta.b === 'Pairs Well') {
      badgeClass = 'pu-badge-pw';
      showBadge = true;
    } else if (meta.b && meta.b.length > 0) {
      badgeClass = 'pu-badge-new';
      showBadge = true;
    }

    var imgSrc = '';
    if (product.images && product.images.length) {
      var bottleImg = product.images.find(function(img) {
        var fn = img.src.split('/').pop().split('?')[0];
        return fn.includes('bottle') || fn.includes('RGB');
      });
      imgSrc = bottleImg ? bottleImg.src : product.images[0].src;
    }
    var specs = SPECS[meta.h] || {d:'', s1:'', s2:''};

    var card = document.createElement('a');
    card.href = '/products/' + meta.h;
    card.className = 'pu-protocol-card';

    var badgeHtml = '';
    if (showBadge) {
      badgeHtml = '<span class="pu-protocol-badge ' + badgeClass + '">' + meta.b + '</span>';
    }

    var bodyHtml = badgeHtml +
      '<div class="pu-protocol-img-wrap">' +
        '<img src="' + imgSrc + '" alt="' + meta.n + '" loading="lazy">' +
      '</div>' +
      '<div class="pu-protocol-body">' +
        '<h3 class="pu-protocol-name">' + meta.n + '</h3>' +
        '<p class="pu-protocol-descriptor">' + specs.d + '</p>' +
        '<div class="pu-protocol-benefits">' +
          '<span class="pu-protocol-check"><span class="pu-protocol-checkmark">' + '\u2713' + '</span> ' + meta.b1 + '</span>' +
          '<span class="pu-protocol-check"><span class="pu-protocol-checkmark">' + '\u2713' + '</span> ' + meta.b2 + '</span>' +
        '</div>' +
        '<div class="pu-protocol-divider"></div>' +
        '<div class="pu-protocol-specs">' +
          '<span class="pu-protocol-spec">' + specs.s1 + '</span>' +
          '<span class="pu-protocol-spec-dot"></span>' +
          '<span class="pu-protocol-spec">' + specs.s2 + '</span>' +
        '</div>' +
        '<div class="pu-protocol-footer">' +
          '<div class="pu-protocol-pricing">' +
            '<span class="pu-protocol-daily">Less than $' + dailyPrice + '/day</span>' +
          '</div>' +
          '<span class="pu-protocol-cta">View Product</span>' +
        '</div>' +
      '</div>';

    card.innerHTML = bodyHtml;
    return card;
  }

  function insertSection(cards) {
    var section = document.createElement('section');
    section.className = 'pu-protocol-section section-reveal visible';

    var header = document.createElement('div');
    header.className = 'pu-protocol-header';
    header.innerHTML = '<h2 class="pu-protocol-headline pu-atmos-glow">Complete your <em>Protocol</em></h2><p class="pu-protocol-subheadline">Pharmacist-formulated to work together.</p>';
    section.appendChild(header);

    var grid = document.createElement('div');
    grid.className = 'pu-protocol-grid';
    for (var i = 0; i < cards.length; i++) {
      grid.appendChild(cards[i]);
    }
    section.appendChild(grid);

    var target = document.querySelector('.pdp-reviews') || document.querySelector('.pu-faq-section');
    if (target && target.parentNode) {
      target.parentNode.insertBefore(section, target);
    }
  }

  var recs = MAP[handle];
  if (!recs || !recs.length) return;

  var promises = [];
  for (var i = 0; i < recs.length; i++) {
    (function(meta) {
      promises.push(
        fetch('/products/' + meta.h + '.json')
          .then(function(res) { return res.json(); })
          .then(function(data) { return { product: data.product, meta: meta }; })
      );
    })(recs[i]);
  }

  Promise.all(promises).then(function(results) {
    var cards = [];
    for (var i = 0; i < results.length; i++) {
      cards.push(buildCard(results[i].product, results[i].meta));
    }
    insertSection(cards);
  }).catch(function(err) {
    console.error('Error loading product recommendations:', err);
  });

})();
